import { ModalTypes } from 'enums/modalTypes';
import { Maybe } from 'generated/graphql';
import { closeModal } from 'graphql/modals';
import { isMobile } from 'helpers/deviceDetect';
import { FC } from 'react';
import CandidateInformationDesktop from './CandidateInformationDesktop/CandidateInformationDesktop';
import CandidateInformationMobile from './CandidateInformationMobile/CandidateInformationMobile';

export type TCandidateInformationModal = {
  stageCandidateId: number;
  companyLogoUrl?: Maybe<string>;
};

const CandidateInformationModal: FC<TCandidateInformationModal> = ({
  stageCandidateId,
  companyLogoUrl,
}) => {
  const handleCloseModal = () => {
    closeModal(ModalTypes.CANDIDATE_INFORMATION);
  };

  if (!isMobile()) {
    return (
      <CandidateInformationDesktop
        onCloseButtonClick={handleCloseModal}
        stageCandidateId={stageCandidateId}
        companyLogoUrl={companyLogoUrl}
        onCandidateInformationProvided={handleCloseModal}
        onCandidateInformationFormPreviouslyCompleted={handleCloseModal}
      />
    );
  } else {
    return (
      <CandidateInformationMobile
        onCloseModal={handleCloseModal}
        stageCandidateId={stageCandidateId}
        companyLogoUrl={companyLogoUrl}
      />
    );
  }
};

export default CandidateInformationModal;
